Vue.component('employee-overview', {
    props: {

    },

    data: function() {
        return {
            activeTab: 0
        }
    },

    created: function created() {
        this.loadActiveTab();
    },

    methods: {
        loadActiveTab: function() {
            // Load the last active tab from localStorage
            const savedTab = localStorage.getItem('employee-overview-active-tab');
            if (savedTab !== null) {
                this.activeTab = parseInt(savedTab);
            }
        },

        onTabChanged: function(tabIndex) {
            this.activeTab = tabIndex;
            // Save the active tab to localStorage
            localStorage.setItem('employee-overview-active-tab', tabIndex.toString());
        }
    },

    filters: {

    },
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/EmployeeOverview.js